import { default as AltaBackground } from './fundo-outubro-rosa-alta.png'
import { default as DefaultBackground } from './fundo-outubro-rosa.png'
import { default as AppStore } from './app-store.svg'
import { default as Becker } from './becker.svg'
import { default as BlueBecker } from './blue-becker.svg'
import { default as BlueGlass } from './blue-glass.svg'
import { default as BlueLogo } from './blue-logo.svg'
import { default as BlueSyringe } from './blue-syringe.svg'
import { default as Calendar } from './calendar.svg'
import { default as CalendarV2 } from './calendar-v2.svg'
import { default as CellPhoneIllustration } from './cell-phone-illustration.svg'
import { default as CellPhoneIllustrationV2 } from './cell-phone-illustration-v2.svg'
import { default as Clock } from './clock.svg'
import { default as ClockV2 } from './clock-v2.svg'
import { default as Exclamation } from './exclamation-mark.svg'
import { default as Facebook } from './facebook.svg'
import { default as FacebookV2 } from './facebook-v2.svg'
import { default as Glass } from './glass.svg'
import { default as GooglePlay } from './google-play.svg'
import { default as HandWithStar } from './hand-with-star.svg'
import { default as HealthInsurace } from './health-insurace.svg'
import { default as Information } from './information.svg'
import { default as Instagram } from './instagram.svg'
import { default as Magnifier } from './magnifier.svg'
import { default as OrangeCalendar } from './orange-calendar.svg'
import { default as OrangeClock } from './orange-clock.svg'
import { default as OrangeMagnifier } from './orange-magnifier.svg'
import { default as PersonAnalysingWithMask } from './person-analyzing-with-mask-illustration.svg'
import { default as PersonAnalysingWithoutMask } from './person-analyzing-without-mask-illustration.svg'
import { default as PersonWithChild } from './person-with-child.svg'
import { default as PersonVaccines } from './person-vaccines.svg'
import { default as PersonCheckup } from './person-checkup.svg'
import { default as PersonTests } from './person-tests.svg'
import { default as Swiping } from './swiping.svg'
import { default as Syringe } from './syringe.svg'
import { default as WhiteLogo } from './white-logo.svg'
import { default as BlueNavDasaLogo } from './blue-nav-dasa-logo.svg'
import { default as WhiteNavDasaLogo } from './white-nav-dasa-logo.svg'
import { default as RedCalendar } from './red-calendar.svg'
import { default as RedClock } from './red-clock.svg'
import { default as RedMagnifier } from './red-magnifier.svg'
import { default as BlueCalendar } from './blue-calendar.svg'
import { default as BlueClock } from './blue-clock.svg'
import { default as BlueMagnifier } from './blue-magnifier.svg'
import { default as DarkBlueCalendar } from './dark-blue-calendar.svg'
import { default as DarkBlueClock } from './dark-blue-clock.svg'
import { default as DarkBlueMagnifier } from './dark-blue-magnifier.svg'
import { default as Coupon } from './coupon.svg'
import { default as CouponAlta } from './coupon-alta.svg'
import { default as Copy } from './copy.svg'

export const Images = {
    DefaultBackground: {
        src: DefaultBackground,
        alt: 'Ilustração de fundo',
    },
    AltaBackground: {
        src: AltaBackground,
        alt: 'Ilustração de fundo da Alta',
    },
    AppStore: {
        src: AppStore,
        alt: 'Ícone da App Store',
    },
    Becker: {
        src: Becker,
        alt: 'Ícone de becker',
    },
    BlueBecker: {
        src: BlueBecker,
        alt: 'Ícone de becker',
    },
    BlueGlass: {
        src: BlueGlass,
        alt: 'Ícone de copo',
    },
    BlueSyringe: {
        src: BlueSyringe,
        alt: 'Ícone de seringa',
    },
    Calendar: {
        src: Calendar,
        alt: 'Ícone de calendário',
    },
    CalendarV2: {
        src: CalendarV2,
        alt: 'Ícone de calendário',
    },
    CellPhoneIllustration: {
        src: CellPhoneIllustration,
        alt: 'Ilustração de um celular',
    },
    CellPhoneIllustrationV2: {
        src: CellPhoneIllustrationV2,
        alt: 'Ilustração de um celular',
    },
    Clock: {
        src: Clock,
        alt: 'Ícone de relógio',
    },
    ClockV2: {
        src: ClockV2,
        alt: 'Ícone de relógio',
    },
    Glass: {
        src: Glass,
        alt: 'Ícone de copo',
    },
    GooglePlay: {
        src: GooglePlay,
        alt: 'Ícone do Google Play',
    },
    HandWithStar: {
        src: HandWithStar,
        alt: 'Ícone de mão com estrela',
    },
    Information: {
        src: Information,
        alt: 'Ícone de informação',
    },
    BlueLogo: {
        src: BlueLogo,
        alt: 'Logotipo Dasa',
    },
    WhiteLogo: {
        src: WhiteLogo,
        alt: 'Logotipo Dasa',
    },
    WhiteNavDasaLogo: {
        src: WhiteNavDasaLogo,
        alt: 'Logotipo Dasa',
    },
    BlueNavDasaLogo: {
        src: BlueNavDasaLogo,
        alt: 'Logotipo Dasa',
    },
    Facebook: {
        src: Facebook,
        alt: 'Ícone do Facebook',
    },
    FacebookV2: {
        src: FacebookV2,
        alt: 'Ícone do Facebook',
    },
    Instagram: {
        src: Instagram,
        alt: 'Ícone do Instagram',
    },
    Magnifier: {
        src: Magnifier,
        alt: 'Ícone de lupa',
    },
    OrangeCalendar: {
        src: OrangeCalendar,
        alt: 'Ícone de calendário',
    },
    OrangeClock: {
        src: OrangeClock,
        alt: 'Ícone de relógio',
    },
    OrangeMagnifier: {
        src: OrangeMagnifier,
        alt: 'Ícone de lupa',
    },
    PersonAnalysingWithMask: {
        src: PersonAnalysingWithMask,
        alt: 'Ilustração de uma pessoa com máscara fazendo análise clínica',
    },
    PersonAnalysingWithoutMask: {
        src: PersonAnalysingWithoutMask,
        alt: 'Ilustração de uma pessoa fazendo análise clínica',
    },
    PersonWithChild: {
        src: PersonWithChild,
        alt: 'Ilustração de uma pessoa segurando uma criança',
    },
    PersonVaccines: {
        src: PersonVaccines,
        alt: 'Ilustração de pessoa segurando comprovante de vacinação',
    },
    PersonCheckup: {
        src: PersonCheckup,
        alt: 'Ilustração de pessoa sentada olhando celular',
    },
    PersonTests: {
        src: PersonTests,
        alt: 'Ilustração de pessoa mostrando o celular',
    },
    Exclamation: {
        src: Exclamation,
        alt: 'Ícone de atenção triangular',
    },
    HealthInsurace: {
        src: HealthInsurace,
        alt: 'Ícone de cartão de convênio',
    },
    Swiping: {
        src: Swiping,
        alt: 'Ícone de deslizar',
    },
    Syringe: {
        src: Syringe,
        alt: 'Ícone de seringa',
    },
    RedCalendar: {
        src: RedCalendar,
        alt: 'Ícone de calendário',
    },
    RedClock: {
        src: RedClock,
        alt: 'Ícone de relógio',
    },
    RedMagnifier: {
        src: RedMagnifier,
        alt: 'Ícone de lupa',
    },
    BlueCalendar: {
        src: BlueCalendar,
        alt: 'Ícone de calendário',
    },
    BlueClock: {
        src: BlueClock,
        alt: 'Ícone de relógio',
    },
    BlueMagnifier: {
        src: BlueMagnifier,
        alt: 'Ícone de lupa',
    },
    DarkBlueCalendar: {
        src: DarkBlueCalendar,
        alt: 'Ícone de calendário',
    },
    DarkBlueClock: {
        src: DarkBlueClock,
        alt: 'Ícone de relógio',
    },
    DarkBlueMagnifier: {
        src: DarkBlueMagnifier,
        alt: 'Ícone de lupa',
    },
    Coupon: {
        src: Coupon,
        alt: 'Cupom de desconto',
    },
    CouponAlta: {
        src: CouponAlta,
        alt: 'Cupom de desconto',
    },
    Copy: {
        src: Copy,
        alt: 'Copiar',
    },
}

export default Images
